import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';

import { toggleSupportLanguagesModal } from 'Redux/ducks/modal';
import store from 'Redux/store';

const SupportedLanguages = ({
  languages,
}) => {
  if (isEmpty(languages)) return false;
  const englishSupported = !!languages.find(l => l === 'English');
  let languagesArray = languages;

  if (englishSupported) {
    languagesArray = languagesArray.filter(l => l !== 'English');
    languagesArray.unshift('English');
  }

  if (languages.length > 1) {
    return (
      <div className="supported-languages-detail">
        <span className="first-language">{languagesArray[0]}</span>
        <Button
          color="link"
          onClick={() => store.dispatch(toggleSupportLanguagesModal({ languages: languagesArray }))}
        >
          +
          <FormattedMessage
            id="new.supportedlanguages.more"
            defaultMessage="{count} more"
            values={{
              count: languages.length,
            }}
          />
        </Button>
      </div>
    );
  }

  return (
    <div>
      {languages[0]}
    </div>
  );
};

SupportedLanguages.propTypes = {
  languages: PropTypes.arrayOf(PropTypes.string),
};

SupportedLanguages.defaultProps = {
  languages: [],
};

export default SupportedLanguages;
